import * as React from "react";
const SvgCross2 = props => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 23" width={16} height={16} {...props}><path d="m1 1.56 19 20.193M20 1.56 1 21.752" fill="none" stroke="#47CFCB" strokeLinecap="round" strokeWidth={2} /></svg>;
export default SvgCross2;